export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/object.59d4451.svg";